import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Container , Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { forgotUser } from '../../actions/userActions';

class Forgotpassword extends Component {
  

  handleSubmit = async (e) => {
    e.preventDefault();
    
    let { forgotUser } = this.props
    let data = new FormData(document.querySelector('#forgot-password-form'));
    forgotUser(data);   
    
  };

  render() {
    let {login} = this.props.userState;

    return (
      <div>
        <Container>
            {login && login.check === 2 ? 
                <div className="alert alert-danger" role="alert">
                    Votre e-mail n'existe pas dans la base 
                </div>
                : 
                null
            }
            {login && login.check === 3 ? 
                <div className="alert alert-danger" role="alert">
                    Problème envoi mail 
                </div>
                : 
                null
            }
            {login && login.check === 1 ?
                <div id="alert-form" >
                    <p className="alert alert-success" role="alert">Vous recevrez un lien pour réinitialiser votre mot de passe sur {login.data.email}!</p>
                </div>
                : 
                <Form onSubmit={this.handleSubmit} id="forgot-password-form"  className="mx-auto">
                    <h2 className="text-center mb-4">Mot de passe oublié ?</h2>
                    <FormGroup>
                        <Label for="exampleEmail" className="text-right">
                        Adresse e-mail:
                        </Label>
                        <Input
                        type="email"
                        name="email"
                        id="email"
                        className="form-control"
                        autoFocus="autofocus"
                        tabIndex="5"
                        placeholder="test@example.com"
                        required
                        />
                    </FormGroup>
                    <FormGroup>
                        <Button type="submit" color="primary">Réinitialiser le mot de passe</Button>
                        <Link to="login" className="btn btn-primary ml-2">Annuler</Link>
                        
                    </FormGroup>
                </Form>
            }
        </Container>
      </div>
    );
  }
}

function mapStateToProps({ userReducer }) {
    return {
      userState: userReducer
    }
  }
  function mapDispatchToProps(dispatch) {
    return {
        forgotUser: bindActionCreators(forgotUser, dispatch),
    }
  }
  
export default connect(mapStateToProps, mapDispatchToProps)(Forgotpassword);





// WEBPACK FOOTER //
// ./src/containers/User/Forgotpassword.js